<div class="my-6 flex justify-center gap-2">
  @for (digit of digits; track $index) {
    <input
      #box
      class="input input-bordered h-12 w-10 px-2 text-center text-xl"
      type="text"
      inputmode="numeric"
      [value]="digit"
      [attr.autocomplete]="$index === 0 ? 'one-time-code' : 'off'"
      (input)="onInput($index, $event)"
      (keydown)="onKeydown($index, $event)"
      (paste)="onPaste($event)"
      (focus)="onFocus($event)"
    />
  }
</div>
